// assets/wishlist.js
window.Wishlist = {
  key: 'wishlist_items',

  get() {
    return JSON.parse(localStorage.getItem(this.key)) || [];
  },

  save(items) {
    localStorage.setItem(this.key, JSON.stringify(items));
  },

  add(handle) {
    const items = this.get();
    if (!items.includes(handle)) {
      items.push(handle);
      this.save(items);
      this.updateUI();
    }
  },

  remove(handle) {
    const items = this.get().filter(item => item !== handle);
    this.save(items);
    this.updateUI();

    // Refresh wishlist page if present
    if (document.getElementById('wishlist-container')) location.reload();
  },

  toggle(handle) {
    const items = this.get();
    if (items.includes(handle)) {
      this.remove(handle);
    } else {
      this.add(handle);
    }
  },

  isInWishlist(handle) {
    return this.get().includes(handle);
  },

  updateUI() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      btn.classList.toggle('is-active', this.isInWishlist(handle));
    });

    const countEl = document.querySelector('[data-wishlist-count]');
    if (countEl) countEl.textContent = this.get().length;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  Wishlist.updateUI();

  document.body.addEventListener('click', e => {
 const path = e.composedPath && e.composedPath();
const btn = path ? path.find(el => el?.hasAttribute?.('data-wishlist-btn')) : e.target.closest('[data-wishlist-btn]');
    if (btn) {
      
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      Wishlist.toggle(handle);
    }
  });
});


